import { getHoursInMS } from "@jurijtokarski/times";

import { getDayStartTimestamp } from "./dates";
import { storage } from "./storage";
import { Measure, Amount, HistoryItem, DEFAULT_DAILY_GOAL, DEFAULT_MEASURE } from "./context";

enum StorageKeys {
  MEASURE = "measure",
  DAILY_GOAL = "daily_goal",
  HISTORY = "history"
};

export const setPersistedMeasure = (value: Measure): Promise<Measure> => storage.set<Measure>(StorageKeys.MEASURE, value);

export const getPersistedMeasure = (): Promise<Measure> => storage.get<Measure>(StorageKeys.MEASURE).then(value => value || DEFAULT_MEASURE);

export const setPersistedDailyGoal = (value: Amount) => storage.set<Amount>(StorageKeys.DAILY_GOAL, value);

export const getPersistedDailyGoal = () => storage.get<Amount>(StorageKeys.DAILY_GOAL).then(value => value || DEFAULT_DAILY_GOAL);

export const getPersistedHistory = () => storage.get<HistoryItem[]>(StorageKeys.HISTORY).then(value => value?.sort((a, b) => b.timestamp - a.timestamp) || []);

export const addPersistedHistoryItem = (item: HistoryItem) => getPersistedHistory().then(items => storage.set(StorageKeys.HISTORY, [...items, item]));

export const removePersistedHistoryItem = (item: HistoryItem) => getPersistedHistory().then(items => storage.set(StorageKeys.HISTORY, items.filter(i => i.timestamp !== item.timestamp)));

export const getPersistedDrinksByRange = (fromDate?: Date, toDate?: Date) => getPersistedHistory().then(items => {
  const from = (fromDate || new Date()).getTime();
  const to = toDate ? toDate.getTime() : from + getHoursInMS(24);
  return items.filter(i => i.timestamp >= from && i.timestamp < to);
});

export const getPersistedTodayDrinks = () => getPersistedDrinksByRange(getDayStartTimestamp());